import { ReactComponent } from './savings-house-xl.svg';
export const SavingsHouseIconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=savings-house-xl.js.map